import VueRouter from "vue-router"
import paths from "./paths"
import store from "../store"

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes: paths,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters["auth/token"]) {
      router.push({ name: "login" })
    } else if (to.meta?.permissions) {
      const permissions = to.meta?.permissions.map((i) => i.role)
      const userRoles = store.getters["auth/roles"]
      if (!userRoles.some((r) => permissions.includes(r))) {
        router.push({ name: "acessoNegado" })
      }
    }
  }
  next()
})

export default router
